import MarkdownComponent from './Markdown';
import MediaRenderComponent from './MediaRender';

export const Markdown = MarkdownComponent;
export const MediaRender = MediaRenderComponent;
